import { combineReducers } from '@reduxjs/toolkit';

import { editSlice } from './edit';
import { fmSlice } from './fm';
import { globalSlice } from './global';
import { homeSlice } from './home';
import { imageSlice } from './image';
import { imageLibrarySlice } from './imageLibrary';
import { mirrorSlice } from './mirror';
import { userSlice } from './user';

export const rootReducer = combineReducers({
  user: userSlice.reducer,
  global: globalSlice.reducer,
  edit: editSlice.reducer,
  home: homeSlice.reducer,
  image: imageSlice.reducer,
  imageLibrary: imageLibrarySlice.reducer,
  mirror: mirrorSlice.reducer,
  fm: fmSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
